import React, {useEffect, useState} from 'react';
import {useAdvancedSearchSCMutation} from "../../core/api/solitaire-state-api";
import MultiSearch from "./MultiSearch";

export default function SearchBarSC() {
    return <MultiSearch useSearchHook={useAdvancedSearchSCMutation} />
}